import { DataAttributeDefinitions } from 'scrivito'

import { pisaContactDataClass } from './Pisa/pisaPersonDataClass'

const attributes: DataAttributeDefinitions = {}

export const Person = pisaContactDataClass(attributes)
